<template>
    <Modal2 :visible="visible" @cancel="$emit('close')" :show-footer="false" title="Gantt Ayarları" large>
        <div class="gantt-settings-modal">
            <a-form :form="form" layout="vertical">
                <!-- Zorunlu Field'lar -->
                <div class="settings-section">
                    <h4>Zorunlu Alanlar</h4>
                    
                    <a-form-item label="Görev Adı Field">
                        <a-select
                            v-decorator="[
                                'taskNameField',
                                {
                                    initialValue: widget.settings.taskNameField,
                                    rules: [{ required: true, message: 'Görev adı field seçiniz' }],
                                },
                            ]"
                            placeholder="Görev adı field seçiniz"
                            show-search
                            :filter-option="filterOption"
                        >
                            <a-select-option
                                v-for="field in stringFields"
                                :key="field._id"
                                :value="field._id"
                            >
                                {{ field.name }}
                            </a-select-option>
                        </a-select>
                    </a-form-item>

                    <a-form-item label="Başlangıç Tarihi Field">
                        <a-select
                            v-decorator="[
                                'startDateField',
                                {
                                    initialValue: widget.settings.startDateField,
                                    rules: [{ required: true, message: 'Başlangıç tarihi field seçiniz' }],
                                },
                            ]"
                            placeholder="Başlangıç tarihi field seçiniz"
                            show-search
                            :filter-option="filterOption"
                        >
                            <a-select-option
                                v-for="field in dateFields"
                                :key="field._id"
                                :value="field._id"
                            >
                                {{ field.name }}
                            </a-select-option>
                        </a-select>
                    </a-form-item>

                    <a-form-item label="Bitiş Tarihi Field">
                        <a-select
                            v-decorator="[
                                'endDateField',
                                {
                                    initialValue: widget.settings.endDateField,
                                    rules: [{ required: true, message: 'Bitiş tarihi field seçiniz' }],
                                },
                            ]"
                            placeholder="Bitiş tarihi field seçiniz"
                            show-search
                            :filter-option="filterOption"
                        >
                            <a-select-option
                                v-for="field in dateFields"
                                :key="field._id"
                                :value="field._id"
                            >
                                {{ field.name }}
                            </a-select-option>
                        </a-select>
                    </a-form-item>
                </div>

                <!-- Opsiyonel Field'lar -->
                <div class="settings-section">
                    <h4>Opsiyonel Alanlar</h4>
                    
                    <a-form-item label="İlerleme Field (%)">
                        <a-select
                            v-decorator="['progressField', { initialValue: widget.settings.progressField }]"
                            placeholder="İlerleme field seçiniz"
                            show-search
                            :filter-option="filterOption"
                            allow-clear
                        >
                            <a-select-option
                                v-for="field in numberFields"
                                :key="field._id"
                                :value="field._id"
                            >
                                {{ field.name }}
                            </a-select-option>
                        </a-select>
                    </a-form-item>

                    <a-form-item label="Durum Field">
                        <a-select
                            v-decorator="['statusField', { initialValue: widget.settings.statusField }]"
                            placeholder="Durum field seçiniz"
                            show-search
                            :filter-option="filterOption"
                            allow-clear
                        >
                            <a-select-option
                                v-for="field in dropdownFields"
                                :key="field._id"
                                :value="field._id"
                            >
                                {{ field.name }}
                            </a-select-option>
                        </a-select>
                    </a-form-item>

                    <a-form-item label="Atanan Kişi Field">
                        <a-select
                            v-decorator="['assigneeField', { initialValue: widget.settings.assigneeField }]"
                            placeholder="Atanan kişi field seçiniz"
                            show-search
                            :filter-option="filterOption"
                            allow-clear
                        >
                            <a-select-option
                                v-for="field in userFields"
                                :key="field._id"
                                :value="field._id"
                            >
                                {{ field.name }}
                            </a-select-option>
                        </a-select>
                    </a-form-item>

                    <a-form-item label="Öncelik Field">
                        <a-select
                            v-decorator="['priorityField', { initialValue: widget.settings.priorityField }]"
                            placeholder="Öncelik field seçiniz"
                            show-search
                            :filter-option="filterOption"
                            allow-clear
                        >
                            <a-select-option
                                v-for="field in dropdownFields"
                                :key="field._id"
                                :value="field._id"
                            >
                                {{ field.name }}
                            </a-select-option>
                        </a-select>
                    </a-form-item>
                </div>

                <!-- Görünüm Ayarları -->
                <div class="settings-section">
                    <h4>Görünüm Ayarları</h4>
                    
                    <a-form-item label="Görünüm Modu">
                        <a-select
                            v-decorator="['viewMode', { initialValue: widget.settings.viewMode || 'month' }]"
                            placeholder="Görünüm modu seçiniz"
                        >
                            <a-select-option value="day">Günlük</a-select-option>
                            <a-select-option value="week">Haftalık</a-select-option>
                            <a-select-option value="month">Aylık</a-select-option>
                            <a-select-option value="quarter">Çeyreklik</a-select-option>
                            <a-select-option value="year">Yıllık</a-select-option>
                        </a-select>
                    </a-form-item>

                    <a-form-item>
                        <a-checkbox
                            v-decorator="[
                                'showProgress',
                                {
                                    initialValue: $_.get(widget, 'settings.customization.showProgress', true),
                                    valuePropName: 'checked',
                                },
                            ]"
                        >
                            İlerleme göster
                        </a-checkbox>
                    </a-form-item>

                    <a-form-item>
                        <a-checkbox
                            v-decorator="[
                                'showWeekends',
                                {
                                    initialValue: $_.get(widget, 'settings.customization.showWeekends', true),
                                    valuePropName: 'checked',
                                },
                            ]"
                        >
                            Hafta sonlarını göster
                        </a-checkbox>
                    </a-form-item>

                    <a-form-item>
                        <a-checkbox
                            v-decorator="[
                                'showToday',
                                {
                                    initialValue: $_.get(widget, 'settings.customization.showToday', true),
                                    valuePropName: 'checked',
                                },
                            ]"
                        >
                            Bugün çizgisini göster
                        </a-checkbox>
                    </a-form-item>
                </div>
            </a-form>

            <div class="modal-footer">
                <SupsisButton @click="$emit('close')">İptal</SupsisButton>
                <SupsisButton primary @click="handleSave">Kaydet</SupsisButton>
            </div>
        </div>
    </Modal2>
</template>

<script>
import Vue from "vue";
import Modal2 from "../../../../../../components/common/Modal2.vue";
import SupsisButton from "../../../../Settings/components/SupsisButton.vue";

export default Vue.extend({
    name: "GanttSettingsModal",
    components: {
        Modal2,
        SupsisButton,
    },
    props: {
        visible: {
            type: Boolean,
            default: false,
        },
        widget: {
            type: Object,
            required: true,
        },
        fields: {
            type: Array,
            required: true,
        },
        table: {
            type: Object,
            required: true,
        },
    },
    data() {
        return {
            form: this.$form.createForm(this),
        };
    },
    computed: {
        stringFields() {
            return this.fields.filter((f) => f.valueType === "string");
        },
        dateFields() {
            return this.fields.filter((f) => f.valueType === "date");
        },
        numberFields() {
            return this.fields.filter((f) => f.valueType === "number");
        },
        dropdownFields() {
            return this.fields.filter((f) => f.fieldType === "dropdown");
        },
        userFields() {
            return this.fields.filter((f) => f.fieldType === "user");
        },
    },
    methods: {
        filterOption(input, option) {
            return option.componentOptions.children[0].text.toLowerCase().includes(input.toLowerCase());
        },
        handleSave() {
            this.form.validateFields((err, values) => {
                if (err) {
                    return;
                }

                const settings = {
                    taskNameField: values.taskNameField,
                    startDateField: values.startDateField,
                    endDateField: values.endDateField,
                    progressField: values.progressField,
                    statusField: values.statusField,
                    assigneeField: values.assigneeField,
                    priorityField: values.priorityField,
                    viewMode: values.viewMode,
                    filters: this.widget.settings.filters || [],
                    searchQuery: this.widget.settings.searchQuery || "",
                    customization: {
                        showProgress: values.showProgress,
                        showWeekends: values.showWeekends,
                        showToday: values.showToday,
                        statusColors: this.$_.get(this.widget, "settings.customization.statusColors", {}),
                        priorityColors: this.$_.get(this.widget, "settings.customization.priorityColors", {}),
                    },
                };

                this.$emit("save", settings);
            });
        },
    },
});
</script>

<style scoped lang="scss">
.gantt-settings-modal {
    .settings-section {
        margin-bottom: 24px;
        padding-bottom: 24px;
        border-bottom: 1px solid #e8e8e8;

        &:last-child {
            border-bottom: none;
        }

        h4 {
            font-size: 16px;
            font-weight: 600;
            margin-bottom: 16px;
            color: #333;
        }
    }

    .modal-footer {
        display: flex;
        justify-content: flex-end;
        gap: 10px;
        padding-top: 24px;
        border-top: 1px solid #e8e8e8;
        margin-top: 24px;
    }
}
</style>

